import Sidebar from "./Components/Sidebar";

function Search() {
    return (
        <div>
            <Sidebar />
            <div className="app">
                <header>
                    <nav className="navbar">
                        <select name="" id="">
                            <input type="sl" name="" id="" />
                            <option value="" selected>All</option>
                            <option value="">Less than 100</option>
                            <option value="">100 to 500</option>
                            <option value="">500 to 3k</option>
                            <option value="">3k to 10k</option>
                            <option value="">10k to 100k</option>
                            <option value="">100k to 1M</option>
                            <option value="">more than 1M</option>
                        </select>
                        <input type="text" placeholder="Search" />
                    </nav>
                </header>
                <section className="main">
                    <div className="profile-card">
                        <div className="image">
                            <div className="insta-user"></div>
                        </div>
                        <div className="data">
                            <h2>@artical_zara</h2>
                            <span>Painting &amp; Illustration</span>
                        </div>
                        <div className="row">
                            <div className="info">
                                <h3>Followers</h3>
                                <span>2310</span>
                            </div>
                            <div className="info">
                                <h3>Posts</h3>
                                <span>86</span>
                            </div>
                        </div>
                        <div className="buttons">
                            <a href="#" className="btn">Message</a>
                            <a href="#" className="btn">Follow Me</a>
                        </div>
                    </div>
                    <div className="profile-card">
                        <div className="image">
                            <div className="insta-user"></div>
                        </div>
                        <div className="data">
                            <h2>@krafts_with_a_k</h2>
                            <span>Craft Artist</span>
                        </div>
                        <div className="row">
                            <div className="info">
                                <h3>Followers</h3>
                                <span>128</span>
                            </div>
                            <div className="info">
                                <h3>Posts</h3>
                                <span>56</span>
                            </div>
                        </div>
                        <div className="buttons">
                            <a href="#" className="btn">Message</a>
                            <a href="#" className="btn">Follow Me</a>
                        </div>
                    </div>
                    <div className="profile-card">
                        <div className="image">
                            <div className="insta-user"></div>
                        </div>
                        <div className="data">
                            <h2>@kkalinina.tech</h2>
                            <span>Technology</span>
                        </div>
                        <div className="row">
                            <div className="info">
                                <h3>Followers</h3>
                                <span>603</span>
                            </div>
                            <div className="info">
                                <h3>Posts</h3>
                                <span>95</span>
                            </div>
                        </div>
                        <div className="buttons">
                            <a href="#" className="btn">Message</a>
                            <a href="#" className="btn">Follow Me</a>
                        </div>
                    </div>
                    <div className="profile-card">
                        <div className="image">
                            <div className="insta-user"></div>
                        </div>
                        <div className="data">
                            <h2>@somogyi.art</h2>
                            <span>Graphic Designer</span>
                        </div>
                        <div className="row">
                            <div className="info">
                                <h3>Followers</h3>
                                <span>922</span>
                            </div>
                            <div className="info">
                                <h3>Posts</h3>
                                <span>219</span>
                            </div>
                        </div>
                        <div className="buttons">
                            <a href="#" className="btn">Message</a>
                            <a href="#" className="btn">Follow Me</a>
                        </div>
                    </div>
                    <div className="profile-card">
                        <div className="image">
                            <div className="insta-user"></div>
                        </div>
                        <div className="data">
                            <h2>@uixworkniyo</h2>
                            <span>UI &amp; UX Designer</span>
                        </div>
                        <div className="row">
                            <div className="info">
                                <h3>Followers</h3>
                                <span>9965</span>
                            </div>
                            <div className="info">
                                <h3>Posts</h3>
                                <span>3011</span>
                            </div>
                        </div>
                        <div className="buttons">
                            <a href="#" className="btn">Message</a>
                            <a href="#" className="btn">Follow Me</a>
                        </div>
                    </div>
                    <div className="profile-card">
                        <div className="image">
                            <div className="insta-user"></div>
                        </div>
                        <div className="data">
                            <h2>@jez_graffiti_art</h2>
                            <span>Painter</span>
                        </div>
                        <div className="row">
                            <div className="info">
                                <h3>Followers</h3>
                                <span>5098</span>
                            </div>
                            <div className="info">
                                <h3>Posts</h3>
                                <span>359</span>
                            </div>
                        </div>
                        <div className="buttons">
                            <a href="#" className="btn">Message</a>
                            <a href="#" className="btn">Follow Me</a>
                        </div>
                    </div>

                    <div className="profile-card">
                        <div className="image">
                            <div className="insta-user"></div>
                        </div>
                        <div className="data">
                            <h2>@teamrebirth_</h2>
                            <span>Dance Crew</span>
                        </div>
                        <div className="row">
                            <div className="info">
                                <h3>Followers</h3>
                                <span>412</span>
                            </div>
                            <div className="info">
                                <h3>Posts</h3>
                                <span>56</span>
                            </div>
                        </div>
                        <div className="buttons">
                            <a href="#" className="btn">Message</a>
                            <a href="#" className="btn">Follow Me</a>
                        </div>
                    </div>

                    <div className="profile-card">
                        <div className="image">
                            <div className="insta-user"></div>
                        </div>
                        <div className="data">
                            <h2>@gracy_burgers</h2>
                            <span>Interior Designer</span>
                        </div>
                        <div className="row">
                            <div className="info">
                                <h3>Followers</h3>
                                <span>245</span>
                            </div>
                            <div className="info">
                                <h3>Posts</h3>
                                <span>26</span>
                            </div>
                        </div>
                        <div className="buttons">
                            <a href="#" className="btn">Message</a>
                            <a href="#" className="btn">Follow Me</a>
                        </div>
                    </div>

                    <div className="profile-card">
                        <div className="image">
                            <div className="insta-user"></div>
                        </div>
                        <div className="data">
                            <h2>@coding_coders</h2>
                            <span>Developers</span>
                        </div>
                        <div className="row">
                            <div className="info">
                                <h3>Followers</h3>
                                <span>6321</span>
                            </div>
                            <div className="info">
                                <h3>Posts</h3>
                                <span>432</span>
                            </div>
                        </div>
                        <div className="buttons">
                            <a href="#" className="btn">Message</a>
                            <a href="#" className="btn">Follow Me</a>
                        </div>
                    </div>

                    <div className="profile-card">
                        <div className="image">
                            <div className="insta-user"></div>
                        </div>
                        <div className="data">
                            <h2>@krishna_nandan</h2>
                            <span>Musician &amp; Singer</span>
                        </div>
                        <div className="row">
                            <div className="info">
                                <h3>Followers</h3>
                                <span>8551</span>
                            </div>
                            <div className="info">
                                <h3>Posts</h3>
                                <span>756</span>
                            </div>
                        </div>
                        <div className="buttons">
                            <a href="#" className="btn">Message</a>
                            <a href="#" className="btn">Follow Me</a>
                        </div>
                    </div>

                    <div className="profile-card">
                        <div className="image">
                            <div className="insta-user"></div>
                        </div>
                        <div className="data">
                            <h2>@noob.gamerz_</h2>
                            <span>Gaming Content Creotor</span>
                        </div>
                        <div className="row">
                            <div className="info">
                                <h3>Followers</h3>
                                <span>198</span>
                            </div>
                            <div className="info">
                                <h3>Posts</h3>
                                <span>63</span>
                            </div>
                        </div>
                        <div className="buttons">
                            <a href="#" className="btn">Message</a>
                            <a href="#" className="btn">Follow Me</a>
                        </div>
                    </div>

                    <div className="profile-card">
                        <div className="image">
                            <div className="insta-user"></div>
                        </div>
                        <div className="data">
                            <h2>@trishi.rai._</h2>
                            <span>Dancer</span>
                        </div>
                        <div className="row">
                            <div className="info">
                                <h3>Followers</h3>
                                <span>237</span>
                            </div>
                            <div className="info">
                                <h3>Posts</h3>
                                <span>96 </span>
                            </div>
                        </div>
                        <div className="buttons">
                            <a href="#" className="btn">Message</a>
                            <a href="#" className="btn">Follow Me</a>
                        </div>
                    </div>
                </section>
                .
            </div>


        </div>
    
    );
}

export default Search;